import { configureStore } from "@reduxjs/toolkit";
import orderReducer from "./masterOrderSlice";
import quotationReducer from "./quotationSlice";
import designReportReducer from "./designReportSlice";
import qcReportReducer from "./qcReportSlice";
import quoteDesignReportReducer from "./quoteDesignReportSlice";
import quoteQcReportReducer from "./quoteQcReportSlice";
import orderReportReducer from "./orderReportSlice";
import quoteOrderReportReducer from "./quoteOrderReportSlice";
import doubtReducer from "./doubtSlice";
import supplierReducer from "./supplierSlice";
import deliveryDashboardReducer from "./deliveryDashboardSlice";
import creditHoldReducer from "./creditHoldSlice";
import purchaseOrderReducer from "./masterPurchaseOrderSlice";
import stockProductsReducer from "./stockProductSlice";
import vendorReducer from "./vendorSlice";
import customerCreditLimitReducer from "./customerCreditLimitSlice";

const store = configureStore({
  reducer: {
    orders: orderReducer,
    quotation: quotationReducer,
    designReport: designReportReducer,
    qcReport: qcReportReducer,
    quoteDesignReport: quoteDesignReportReducer,
    quoteQcReport: quoteQcReportReducer,
    orderReport: orderReportReducer,
    quoteOrderReport: quoteOrderReportReducer,
    doubt: doubtReducer,
    supplier: supplierReducer,
    deliveryDashboard: deliveryDashboardReducer,
    creditHold: creditHoldReducer,
    purchaseOrders: purchaseOrderReducer,
    stockProducts: stockProductsReducer,
    vendors: vendorReducer,
    customerCreditLimit: customerCreditLimitReducer,
  },
});

export default store;
